/**
 * Hook: useAuth
 * Maneja autenticación y estado del usuario
 */

import { useEffect } from 'react'
import useCRMStore from '../store/useCRMStore'
import { authAPI } from '../services/api'

export const useAuth = () => {
  const { user, token, setAuth, logout } = useCRMStore()

  // Restaurar sesión de localStorage al montar
  useEffect(() => {
    // [F2] El canje legacy->cookie corre en main.jsx ANTES de montar React (gate anti-race).
    // Aqui solo restaurar el user de UI; la validez real la decide el server (401 -> modal).
    if (!user && authAPI.isAuthenticated()) {
      const savedUser = authAPI.getCurrentUser()
      if (savedUser) {
        setAuth(savedUser, null)
      }
    }
  }, [])

  const login = async (phone, password) => {
    try {
      const response = await authAPI.login(phone, password)
      setAuth(response.user, response.token)
      return { success: true }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Error al iniciar sesión'
      }
    }
  }

  const handleLogout = () => {
    authAPI.logout()
    logout()
  }

  return {
    user,
    token,
    // [F2] Autenticado = hay user recordado; el server es quien valida de verdad (401).
    isAuthenticated: !!user,
    login,
    logout: handleLogout
  }
}
